import styled from "styled-components";
import { useState } from "react";
import { RAButtonPrimary, RATextInput, RATypography } from "@/components/customs";
import { Row, Col, Modal, Divider } from "antd";
import { IconCloseSvg } from "@/components/svgs";
import { useSelector, useDispatch } from "react-redux";
import { fetchUpdateUserInfo, selectAuthState } from "@/stores/slices/authSlice";
import { isEmpty } from "lodash";
import { toast } from "@/modules/toast";
import { NOTIFICATION_TYPE } from "@/config/constants";
import { getContactKey } from "@/utils";

const initFormAddContact = {
	name: "",
	phone: "",
};

export function ModalAddContact({ visible = false, onClose, onAddContactSuccess }) {
	const dispatch = useDispatch();
	const { user } = useSelector(selectAuthState);
	const [formAddContact, setFormAddContact] = useState(initFormAddContact);
	const [error, setError] = useState({});

	const onAddContact = async () => {
		let err = {};
		if (!formAddContact.name || !formAddContact?.name.trim()) {
			err.name = "Please enter contact name.";
		}
		if (!formAddContact.phone) {
			err.phone = "Please enter phone number.";
		}

		const contact = {
			name: formAddContact.name.trim(),
			phone: formAddContact.phone,
		};

		if (isEmpty(err)) {
			// Identical contacts cannot be told apart in the contact list, so reject them.
			let key = getContactKey(contact);
			if ((user?.contacts ?? []).some((v) => getContactKey(v) === key)) {
				err.phone = "This contact already exists.";
			}
		}

		if (!isEmpty(err)) {
			setError(err);
			return;
		}
		setError({});

		let newContact = [...(user?.contacts ?? [])];
		newContact.push(contact);
		const payload = { ...user, contacts: newContact };
		let response = await dispatch(fetchUpdateUserInfo(payload));
		if (response && response.payload) {
			onAddContactSuccess?.(contact);
			setFormAddContact(initFormAddContact);
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "Something went wrong. Please try again later.",
			});
		}
	};

	return (
		<StyledModal
			centered
			data-testid="AddContact_modal"
			closeIcon={<IconCloseSvg />}
			open={visible}
			onCancel={() => {
				onClose(false);
				setFormAddContact(initFormAddContact);
			}}
			footer={null}
			width="720px"
			wrapClassName="auth-wrapper"
		>
			<ContainerAddContact>
				<Row>
					<Col md={24}>
						<WrapperContent>
							<RATypography variant="h3">Add Contact</RATypography>
						</WrapperContent>
						<RATypography variant="body3" top="12px" color="#595959">
							To add additional contacts to this account, please fill out the information below.
						</RATypography>
					</Col>
				</Row>
				<Divider />
				<Row gutter={[20, 20]}>
					<Col md={24} xs={24}>
						<RATextInput
							data-testid="AddContact_nameInput"
							title="Name"
							placeholder="Enter contact name"
							value={formAddContact.name}
							error={error?.name}
							onChange={(val) =>
								setFormAddContact({
									...formAddContact,
									name: val,
								})
							}
						/>
					</Col>
					<Col md={24} xs={24}>
						<RATextInput
							data-testid="AddContact_phoneInput"
							title="Phone"
							placeholder="Enter phone number"
							type="phone"
							onCountryChange={() => {}}
							value={formAddContact.phone}
							error={error?.phone}
							onChange={(val) =>
								setFormAddContact({
									...formAddContact,
									phone: val,
								})
							}
						/>
					</Col>
				</Row>
				<Row justify="center" align="middle" style={{ marginTop: "40px" }}>
					<RAButtonPrimary data-testid="AddContact_submitBtn" title="DONE" onClick={() => onAddContact()} />
				</Row>
			</ContainerAddContact>
		</StyledModal>
	);
}

const StyledModal = styled(Modal)`
	.ant-modal-content {
		background-color: #ffffff;
		border-radius: 24px;
		box-shadow: none;
	}
	.ant-modal-close {
		width: 28px;
		height: 28px;
		top: 22px;
		right: 22px;
		@media (max-width: 576px) {
			top: 22px;
			right: 4px;
		}
	}
	.ant-modal-body {
		overflow-y: auto;
		overflow-x: hidden;
		max-height: 80vh;
	}
`;
const ContainerAddContact = styled.div`
	width: "100%";
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);
`;
const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
